import { useGameStoryPatterns } from './useGameStoryPatterns'

/**
 * Loads the source game's story-pattern mix benchmarked against the comparison
 * target: another game (`targetGameId`) or a genre (`targetGenreId`).
 */
export const useCompareStoryPatterns = (sourceGameId: string | null, targetGameId: string | null, targetGenreId: string | null) =>
  useGameStoryPatterns(sourceGameId, targetGameId, targetGenreId)
